var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('code',{staticClass:"d-block mt-2 p-1"},[(_vm.usePre)?_c('pre',{domProps:{"innerHTML":_vm._s(_vm.code)}}):_c('div',{domProps:{"innerHTML":_vm._s(_vm.code)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }